package com.appcreator.shared

import kotlin.String

internal object BuildKonfig {
  public val recaptureId: String = "6LdR8XkrAAAAAJlwQ5EOAcNOv5T_z2s8IdIhTteR"

  public val firebaseApiKey: String = "AIzaSyCNhguOsMqbB1HUhu7-PgV6rYbM_crdrjQ"

  public val firebaseAuthDomain: String = "the-daily-cardio.firebaseapp.com"

  public val firebaseProjectId: String = "the-daily-cardio"

  public val firebaseStorageBucket: String = "the-daily-cardio.firebasestorage.app"

  public val firebaseGcmSenderId: String = "241174275056"

  public val firebaseApplicationId: String = "1:241174275056:web:60a1bf491ff04c81f87335"

  public val firebaseGaTrackingId: String = "G-ZTYCRKT4K4"
}
